[
  { "name": "Texas", "abbreviation": "TX" }
]